import {createContext} from '@esgi/ui';
import {SingleSelectedState} from '../../types';
import {Dispatch} from 'react';

export type SingleSelectContextValue = {
	selected: SingleSelectedState,
	select: Dispatch<Partial<SingleSelectedState>>,
};

export const {Context, useHook: useSingleSelectContext} = createContext<SingleSelectContextValue>('SingleSelect', true);